import { SortOrder } from 'antd/es/table/interface';
import { FilterParams } from '../pages/AdministrationOfContinuousEducation/liste-prezenca-for-trainings.component';

export interface PaginationReturn<T> {
  currentPage: number;
  totalPages: number;
  totalElements: number;
  data: T[];
}

export interface PaginationProps {
  size: number;
  page: number;
  sortField?: string;
  sortOrder?: 'asc' | 'desc';
  order?: SortOrder;
}

export const initialQueryState: FilterParams = {
  page: 0,
  loading: false,
  hasMore: true,
  size: 10,
  search: '',
};

export type SetQueryParamsType = React.Dispatch<
  React.SetStateAction<FilterParams>
>;
